"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckInOut = void 0;
var centralized_zod_1 = require("@ipis/centralized-zod");
/*
    Could use a better name
*/
var CheckInOut;
(function (CheckInOut) {
    /*
    Domain
    */
    CheckInOut.Schema = centralized_zod_1.z.object({
        date: centralized_zod_1.z.date(),
    });
})(CheckInOut || (CheckInOut = {}));
exports.CheckInOut = CheckInOut;
